import {useTranslation} from 'react-i18next';
import {useAgentChatContext} from '../../context/AgentChatContext';
import styles from './styles.module.css';

const ACTIVE_STATUSES = new Set(['ready', 'streaming', 'submitted']);

export default function ConnectionBanner() {
  const {t} = useTranslation();
  const {status} = useAgentChatContext();

  if (ACTIVE_STATUSES.has(status)) {
    return null;
  }

  if (status === 'error') {
    return (
      <div className={`${styles.banner} ${styles.bannerError}`}>
        {t('chatsocket.connection.connection_error')}
      </div>
    );
  }

  return null;
}
